<!-- <div nz-row nzJustify="end">
  <button nz-button (click)="onOpenUserInfo()">Modal</button>
</div> -->


<div class="popup-form"> 
<form nz-form [formGroup]="validateForm"  [nzLayout]="'vertical'">
  <nz-row nzGutter="12"> 
    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
      <nz-form-label nzRequired>Tỉnh Thành</nz-form-label>
      <nz-select style="width: 100%;" nzMode="tags" nzPlaceHolder="Tag Mode" [(ngModel)]="listOfTagOptions"  [ngModelOptions]="{standalone: true}">
        <nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label" [nzValue]="option.value"></nz-option>
      </nz-select>
      </nz-form-item>
    </nz-col>

    <nz-col nzLg="12" nzMd="12" nzSm="24">
      <nz-form-item>
        <nz-form-label nzRequired>Trường</nz-form-label>
        <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">

          <input placeholder="try to type"  nz-input [(ngModel)]="inputValue" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange($event)" [nzAutocomplete]="auto" />
          <nz-autocomplete [nzDataSource]="filteredOptions" #auto></nz-autocomplete>

          <ng-template #userErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"> Please input your password! </ng-container>
            <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </nz-col> 
  
  </nz-row> 
  

 

<nz-row nzGutter="12">  
  <nz-col nzLg="12" nzMd="12" nzSm="24">
    <nz-form-item>
      <nz-form-label nzRequired>Trường</nz-form-label>
      <nz-form-control nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="userErrorTpl">

        <input matInput required readonly >
        <button (click)="suffixFileClick()" id="button-file" matSuffix></button>

        <ng-template #userErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')"> Please input your password! </ng-container>
          <ng-container *ngIf="control.hasError('duplicated')"> The username is redundant! </ng-container>
        </ng-template>
        <input #file id="file-selector" type="file" style="display:none;" (change)="finishUpload($event.target.files)">
      </nz-form-control>
    </nz-form-item>
  </nz-col> 

</nz-row> 
  <nz-divider></nz-divider>

  <div *nzModalFooter> 
    <button nz-button nzType="default" (click)="destroyModal()">Đóng</button>
    <button nz-button nzType="primary" (click)="destroyModal()">Lưu</button>
  </div>
</form>
</div>